export enum SlideLocation {
  homepage = 'homepage'
}

export enum SlideEntityType {
  event = 'event'
}

export type SlideObject = {
  id: number
  title: string
  venue: string
  price?: number | string
  date: string
  ageCategory: string
  category: string
  buttonTitle?: string
}

export type SlideDTO = {
  id: number
  posterImage: string
  mobilePosterImage: string
  entity: {
    type: SlideEntityType
    object: SlideObject
  }
}

export type SliderResponse = {
  mobile: SlideDTO[]
  desktop: SlideDTO[]
}

export type Slide = {
  id: number
  posterImage: string
  mobilePosterImage: string
  entityType: SlideEntityType
  object: NonNullable<SlideObject> & {
    buttonText: string
    link: string
  }
}
